import { render, staticRenderFns } from "./favoritos.vue?vue&type=template&id=5b1dd484"
import script from "./favoritos.vue?vue&type=script&lang=js"
export * from "./favoritos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports